import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { ColumnFiltersState, PaginationState, SortingState } from '@tanstack/react-table';
import { snakeCase } from 'lodash';

import {
    Configuration,
    FilterType,
    GetPreTradePortfolioRequest,
    TransactionApi,
} from '../_openapi/portfolio-optimizer';
import { processFilter } from '../widgets/filters/filterUtils';
import { defaultApiConfig } from './defaultApiConfig';

const transactionApi = new TransactionApi(new Configuration(defaultApiConfig));

export const useTransactions = ({
    pagination,
    sorting,
    columnFilters,
    dataVariant,
}: {
    pagination?: PaginationState;
    sorting?: SortingState;
    columnFilters?: ColumnFiltersState;
    dataVariant?: string;
}) =>
    useQuery({
        queryKey: ['transaction', 'list', { pagination, sorting, columnFilters, dataVariant }],
        queryFn: () => {
            const query: GetPreTradePortfolioRequest = {};

            if (pagination) {
                query.pageIndex = pagination.pageIndex;
                query.pageSize = pagination.pageSize;
            }

            if (sorting?.length) {
                query.sortLabel = snakeCase(sorting[0].id);
                query.sortDesc = sorting[0].desc;
            }

            if (columnFilters?.length) {
                query.filter = columnFilters.map(processFilter);
            }

            if (dataVariant === 'cash') {
                query.filter = [
                    ...(query.filter || []),
                    {
                        type: FilterType.LIST,
                        field: 'type',
                        value: [
                            {
                                field: 'type',
                                type: FilterType.STRING,
                                value: 'Deposits',
                            },
                            {
                                field: 'type',
                                type: FilterType.STRING,
                                value: 'Withdrawals',
                            },
                        ],
                    },
                ];
            }

            if (dataVariant === 'transfers') {
                query.filter = [
                    ...(query.filter || []),
                    {
                        type: FilterType.LIST,
                        field: 'type',
                        value: [
                            {
                                field: 'type',
                                type: FilterType.STRING,
                                value: 'Transfer In',
                            },
                            {
                                field: 'type',
                                type: FilterType.STRING,
                                value: 'Transfer Out',
                            },
                        ],
                    },
                ];
            }

            return transactionApi.getTransactions(query);
        },
        placeholderData: keepPreviousData,
    });

export const getTransactions = (query: GetPreTradePortfolioRequest) => transactionApi.getTransactions(query);
